import React from 'react';
import './style.css';

const NoData: React.FC = () => (
  <div className="no-data">Недостаточно данных для отображения отчета</div>
);

export default NoData;
